/**
 * VintagePro Premium — lightweight scroll-reveal animations.
 * Uses IntersectionObserver only (no external libraries) for
 * Core Web Vitals friendliness. Adds `.vp-in-view` to any element
 * with class `.vp-animate` once it enters the viewport.
 */
(function () {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    // Fallback: reveal everything immediately if IO unsupported
    document.querySelectorAll('.vp-animate').forEach(function (el) {
      el.classList.add('vp-in-view');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vp-in-view');
          obs.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  function observeAll() {
    document.querySelectorAll('.vp-animate:not(.vp-in-view)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // Re-scan when Shopify section editor re-renders sections
  document.addEventListener('shopify:section:load', observeAll);
})();
